module.exports = __webpack_public_path__ + "img/bg.78352275.png";